import * as React from 'react';
import './Link.scss';

export enum LinkColor {
    White = 'white',
    Orange = 'orange',
}
export interface IProps {
    title: string;
    href?: string;
    white?: boolean;
    color?: LinkColor;
    small?: boolean;
}

export interface IFunctions {
    onClick?: () => void;
}

export type IAllProps = IProps & IFunctions;

export const Link: React.SFC<IAllProps> = ({ title, href, onClick, color, small }) =>
    <a
        className={`Link-wrap
        link-color-${color || LinkColor.Orange}
        ${small && 'small-size'}
        `}
        href={`${href || '#'}`}
        onClick={e => {
            if (onClick) {
                e.preventDefault();
                onClick();
            }
        }}>
        {title}
    </a>;

export default Link;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/link/Link.tsx